import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Box, List, ListItemButton, ListItemIcon, ListItemText, Typography } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import LanguageIcon from "@mui/icons-material/Language";
import ListIcon from '@mui/icons-material/List';

const Sidebar = () => {
  const location = useLocation();

  const links = [
    { to: "/", label: "Dashboard", icon: <HomeIcon /> },
    { to: "/domains", label: "Domains", icon: <LanguageIcon /> },
    { to: "/listdomains", label: "ListDomains", icon: <ListIcon /> },
  ];

  return (
    <Box
      sx={{
        width: 240,
        height: "100vh",
        bgcolor: "#1F2937",
        color: "white",
        display: "flex",
        flexDirection: "column",
        p: 2,
      }}
    >
      <Box sx={{ mb: 4, textAlign: "center" }}>
        <img
          src="https://ik.imagekit.io/xiao/komdigi.png"
          alt="komdigi"
          style={{ width: 160, height: "auto", margin: "0 auto" }}
        />
      </Box>

      <List component="nav" sx={{ flexGrow: 1 }}>
        {links.map(({ to, label, icon }) => {
          const active = location.pathname === to;
          return (
            <ListItemButton
              key={to}
              component={Link}
              to={to}
              selected={active}
              sx={{
                mb: 1,
                borderRadius: 1,
                color: "white",
                bgcolor: active ? "rgba(139, 92, 246, 0.15)" : "transparent",
                "&:hover": {
                  bgcolor: "rgba(255, 255, 255, 0.1)",
                },
              }}
            >
              <ListItemIcon sx={{ color: active ? "#8b5cf6" : "white" }}>
                {icon}
              </ListItemIcon>
              <ListItemText
                primary={
                  <Typography
                    sx={{ fontWeight: active ? "700" : "500" }}
                    variant="body1"
                  >
                    {label}
                  </Typography>
                }
              />
            </ListItemButton>
          );
        })}
      </List>

      <Box sx={{ textAlign: "center", fontSize: 12, color: "#777", mt: "auto" }}>
        &copy; 2025 Komdigi
      </Box>
    </Box>
  );
};

export default Sidebar;
